<template>
  <div class="wrapper">
    <div class="form">
      <van-form @submit="onSubmit">
        <div class="formWrapper">
          <div class="panel">
            <div class="title">服务卡查询</div>
            <div class="discription">
              <van-icon name="info-o" />
              支持手机号，串码，服务卡查询
            </div>
            <van-field class="_van_btn" v-model="formData.keyword" name="search" label="信息" required
              placeholder="输入手机号,串码,或服务卡号" :rules="[
                { required: true, message: '清输入手机号,串码,或服务卡号' },
              ]">
              <van-icon @click="onScan" slot="right-icon" name="scan" />
              <van-button @click="()=>cameraScan(0, 3)" :icon="carema_src" slot="button" style="margin-top: -6px;"
                size="mini" hairline round type="danger">
                拍照识别
              </van-button>
            </van-field>
          </div>
        </div>
        <div style="margin: 16px">
          <van-button round block type="danger" native-type="submit">查询</van-button>
        </div>
      </van-form>
    </div>
    <van-cell-group>
      <van-cell v-for="item in items" :key="item.code" :title="item.groupName" :label="item.code" :value="statusMap[item.status]" isLink
        @click="linkTo(item.status, item.code)" >
   
        </van-cell>
    </van-cell-group>
    <loadingMask :isShow="showLoding" />
  </div>
</template>

<script>
  import {
    getUserInfo
  } from "@/api";
  import {
    statusMap
  } from "@/utils/common.js";
  import loadingMask from "@/components/loadingMask.vue";
  import {
    getScanCode
  } from "@/utils/wxSDK";

  export default {
    name: "searchCode",
    components: {
      loadingMask,
    },
    computed: {
      items: function() {
        return this.list.filter(function(item) {
          return item.status != 0;
        });
      },
    },
    data() {
      return {
        carema_src: require("@/assets/carema.png"),
        formData: {
          keyword: "",
        },
        list: [],
        showLoding: false,
        statusMap,
      };
    },
    mounted() {
      window.document.title = "服务卡查询";

      // 从 URL 获取 code 参数
      if (this.$route.query.code) {
        this.formData.keyword = this.$route.query.code;
      } else if (!!window.localStorage.getItem('_scanCode_3')) {
        const _scanCode_3 = window.localStorage.getItem('_scanCode_3');
        this.formData.keyword = !!_scanCode_3 ? _scanCode_3 : (!!this.formData.keyword ? this.formData.keyword :
          '')
        window.localStorage.removeItem('_scanCode_3');
      }
    },
    methods: {
      cameraScan(inputNum, code_type) {
        console.log("rinputNumes - - -", inputNum);

        // code_type 1-激活码 2-串号 3-信息
        if (code_type == 3) {
          window.localStorage.removeItem('_scanCode_3')
          this.$router.push({
            path: '/scanCodePage?ind=' + inputNum + '&code_type=3'
          })
        }
      },
      onScan() {
        getScanCode().then((res) => {
          this.formData.keyword = res;
        });
      },
      onSubmit(e) {
        this.showLoding = true;
        getUserInfo(this.formData).then((res) => {
          const response = res.data;
          if (response.code === "200") {
            this.list = response.data;
          } else {
            this.$toast.error(response.msg);
          }
          this.showLoding = false;
        });
      },
      linkTo(status, code) {
        this.$router.push({
          path: "/codeDetail",
          query: {
            code,
            status,
          },
        });
        console.log(status, code);
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
  .wrapper {
    background: url("https://www.servicefun.cn/static/img/bg.png") no-repeat;
    overflow: auto;
    background-size: 100%;
    background-color: #f0f0f0;

    .formWrapper {
      width: 340px;
      background: #fff;
      margin: 0 auto;
      margin-top: 36px;
      border-radius: 10px;
      overflow: hidden;
      padding-bottom: 20px;
    }

    .panel {
      .title {
        padding: 10px 16px;
      }

      /deep/ ._van_btn {
        .van-field__button {
          margin-top: -6px;
        }
      }

      /deep/ .van-uploader {
        width: 300px;
        padding: 10px 16px;
      }

      .upladerBtn {
        background-color: #e2e2e2;
        border: none;
        width: 300px;
        height: 100px;
      }
    }

    .discription {
      padding: 10px 16px;
      font-size: 12px;
      color: #908c8c;

      p {
        margin-top: 6px;
        line-height: 20px;
      }
    }

    /deep/ .van-cell-group .van-cell__title {
      flex: 3;
      color: #646566;
      max-width: 75%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    /deep/ .van-cell-group .van-cell__value {
      flex: 1;
      color: #8e8e8e;
      text-align: right;
      max-width: 25%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/searchCode/index.vue